import { gql } from '@apollo/client'

export const navigationMenuItemFragment = gql`
  fragment NavigationMenuItemFragment on MenuItem {
    id
    path
    label
    parentId
  }
`
